import { DEMO_ENTITY } from '../catalogs/banks.js';
import { z } from 'zod';
/**
 * Identificación legal de la entidad que otorga el crédito (el tenant), para extractos y
 * comprobantes. Cada entidad la configura en `tenant.settings.lender`: la plataforma (Paguz) nunca
 * escribe el nombre de la entidad en el código.
 *
 * Fuentes: Ley 1328 de 2009 (art. 9 información al consumidor; arts. 13-14 Defensor del Consumidor
 * Financiero), Circular Básica Jurídica de la SFC (C.E. 029/2014) Parte I, Título III, Capítulo I.
 */
export const ConsumerOmbudsmanSchema = z
    .object({
    /** Nombre del Defensor del Consumidor Financiero (principal). */
    name: z.string().min(1),
    email: z.string().min(3),
    phone: z.string().min(3),
    address: z.string().min(3),
    /** Horario de atención (texto libre). */
    hours: z.string().optional(),
})
    .meta({ id: 'ConsumerOmbudsman' });
export const LenderProfileSchema = z
    .object({
    /** Razón social, p. ej. "Banco Aliado S.A.". */
    legalName: z.string().min(1),
    /** NIT con dígito de verificación (`900.123.456-7`). `null` = sin configurar. */
    nit: z.string().nullable(),
    /** Dirección de notificación / domicilio principal. */
    address: z.string().nullable(),
    /** Líneas de atención al cliente (texto que se imprime tal cual). */
    customerServicePhone: z.string().nullable(),
    website: z.string().nullable(),
    /** Vigilada por la Superintendencia Financiera de Colombia (leyenda "Vigilado"). */
    supervisedBySfc: z.boolean(),
    consumerOmbudsman: ConsumerOmbudsmanSchema.nullable(),
    /** `true` mientras los datos sean de demostración (los documentos lo advierten). */
    isPlaceholder: z.boolean(),
})
    .meta({ id: 'LenderProfile' });
/**
 * Perfil de la entidad ficticia del demo. **PLACEHOLDERS**: NIT, dirección y Defensor no son reales.
 */
export const DEMO_LENDER_PROFILE = {
    legalName: `${DEMO_ENTITY.name} S.A.`,
    nit: '900.000.000-0',
    address: 'Calle 100 # 10-00, Bogotá D.C.',
    customerServicePhone: '601 000 0000 · 01 8000 000 000',
    website: 'bancoaliado.example',
    supervisedBySfc: true,
    consumerOmbudsman: {
        name: 'Defensoría del Consumidor Financiero (demo)',
        email: 'defensor@bancoaliado.example',
        phone: '601 000 0001',
        address: 'Carrera 7 # 70-00, Bogotá D.C.',
        hours: 'Lunes a viernes, 8:00 a. m. a 5:00 p. m.',
    },
    isPlaceholder: true,
};
/** Perfil legal del tenant; si no está configurado, solo el nombre visible (sin NIT ni Defensor). */
export function lenderProfileOf(settings) {
    return (settings.lender ?? {
        legalName: settings.displayName,
        nit: null,
        address: null,
        customerServicePhone: null,
        website: null,
        supervisedBySfc: true,
        consumerOmbudsman: null,
        isPlaceholder: true,
    });
}
//# sourceMappingURL=lender.js.map